import React from 'react';
import { PrivateMeetingSessionDetailsListResponseType } from '../../../../lib/api';
import { DefaultCarouselView } from '../../../../lib/api/custom-page.types';
import { EventType } from '../../SessionWrapper/LayoutWrapper';
import Button from '../../../../components/button';
import { Carousel } from '../../SessionWrapper/CarouselLayout/Carousel';
import ReplaysFeatureMeetingTile from '../ReplaysFeatureMeetingTile';
import ReplaysMeetingTile from '../ReplaysMeetingTile';
import { MediaQueryContextType, useMediaQuery } from '../../../../lib/context-providers/media-query-provider';
import { useTrackCollapse } from './useTrackCollapse';

interface IProps {
  track: string;
  featuredSessions: PrivateMeetingSessionDetailsListResponseType;
  sessions: PrivateMeetingSessionDetailsListResponseType;
  event: EventType;
  defaultCarouselView?: DefaultCarouselView;
}

const ReplaysTrackItem = ({ track, featuredSessions, sessions, event, defaultCarouselView }: IProps): JSX.Element => {
  const { isMobile } = useMediaQuery() as MediaQueryContextType;
  const {
    isCarouselView,
    isTrack,
    toggle,
    expandButtonText,
    shouldRenderExpandButton,
    shouldRenderTrackExpandButton,
  } = useTrackCollapse({
    track,
    defaultCarouselView,
    nonFeaturedCount: sessions.length,
  });
  const sessionsCount = sessions.length + featuredSessions.length;

  return (
    <div className='meeting-card-grouped-track-wrapper'>
      <div className='meeting-card-grouped-track__title-block flex items-center justify-between'>
        <div>
          {isTrack && (
            <span className='meeting-card-grouped-track__title'>{track}</span>
          )}
          <span className='meeting-card-grouped-track__count-title'> {sessionsCount} {sessionsCount === 1 ? 'Session' : 'Sessions'} </span>
        </div>
        {shouldRenderTrackExpandButton && (
          <Button.Common
            name='show-all-top'
            className='button-expand flex mr-4'
            onClick={toggle}
          >
            {expandButtonText} <span className='button-expand-text'>{track}</span>
          </Button.Common>
        )}
      </div>
      {!!featuredSessions.length && (
        <div className='meeting-card-grouped-track__card-wrapper'>
          {featuredSessions.map(featuredMeeting =>
            isMobile
              ? (
                <ReplaysMeetingTile
                  key={featuredMeeting.meetingId}
                  meeting={featuredMeeting}
                  timeZone={event.timeZone}
                  event={event}
                />
              )
              : (
                <ReplaysFeatureMeetingTile
                  key={featuredMeeting.meetingId}
                  meeting={featuredMeeting}
                  timeZone={event.timeZone}
                />
              )
          )}
        </div>
      )}
      {!!sessions.length && (
        isCarouselView
          ? (
            <div className='replays-carousel-wrapper'>
              <Carousel>
                {sessions.map(session => (
                  <ReplaysMeetingTile
                    key={session.meetingId}
                    event={event}
                    meeting={session}
                    timeZone={event.timeZone}
                    isCarousel
                  />
                ))}
              </Carousel>
            </div>
          )
          : (
            <div className='meeting-card-grouped-track__card-wrapper'>
              {sessions.map(session => (
                <ReplaysMeetingTile
                  key={session.meetingId}
                  event={event}
                  meeting={session}
                  timeZone={event.timeZone}
                />
              ))}
            </div>
          )
      )}
      {shouldRenderExpandButton && (
        <div className='flex w-full justify-center mt-4 m-bottom-30px'>
          <Button.Common
            name='show-all-bottom'
            className='button-expand flex'
            onClick={toggle}
          >
            {expandButtonText}{isTrack && <span className='button-expand-text'>{track}</span>}
          </Button.Common>
        </div>
      )}
      <div className='meeting-card-grouped-track-wrapper__line-block'>
        <div className='meeting-card-grouped-track-wrapper__line' />
      </div>
    </div>
  );
};

export default ReplaysTrackItem;
